import { BaseController } from "@stimulus-library/utilities";
export class AlertController extends BaseController {
    alert() {
        alert(this.messageValue);
    }
}
AlertController.values = { message: String };
